var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "thumbnails"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('article', {
      class: {
        'active': _vm.activeIndex == index
      }
    }, [_c('a', {
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.selectImage(item, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgix_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1e1114e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gallery/Thumbs.vue
// module id = VcO6
// module chunks = 0